/**
 * MODULE: _shared/frontend-shell/src/layout/shellDrawerLayout.ts
 * PURPOSE: Shared z-index and TopBar offset for shell right slide-out panels (UAT sticky-nav fix).
 * PUBLIC_API: SHELL_TOPBAR_HEIGHT_VAR, shellDrawerBelowTopBarStyle, shellDrawerPanelStyle, SHELL_DRAWER_* classes
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 32 / 150 lines
 * RECENT: 2026-06-14 [2.2.1385] — TopBar offset tokens for shell right drawers.
 */

import type { CSSProperties } from 'react';

/** CSS var measured by ShellTopBarMetrics; fallback matches index.css until first paint. */
export const SHELL_TOPBAR_HEIGHT_VAR = 'var(--shell-topbar-height, 4.25rem)';

/** Full-bleed overlay region below the shell TopBar (backdrop + flex host for CRM-style drawers). */
export const shellDrawerBelowTopBarStyle: CSSProperties = {
  top: SHELL_TOPBAR_HEIGHT_VAR,
  left: 0,
  right: 0,
  bottom: 0,
};

/** Right-edge panel anchored below TopBar through viewport bottom. */
export const shellDrawerPanelStyle: CSSProperties = {
  top: SHELL_TOPBAR_HEIGHT_VAR,
  bottom: 0,
};

export const SHELL_DRAWER_BACKDROP_CLASS =
  'fixed inset-0 z-[105] bg-black/30 dark:bg-gray-900/50';

export const SHELL_DRAWER_PANEL_CLASS =
  'fixed right-0 z-[110] flex w-full max-w-md flex-col border-l border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-800';
